import React, { useCallback, useEffect, useState } from "react";
import DmnViewer from 'dmn-js/lib/Modeler';

import "./style.css";
import camundaModdle from 'camunda-dmn-moddle/resources/camunda';
import propertiesPanelModule from 'dmn-js-properties-panel';
import drdAdapterModule from 'dmn-js-properties-panel/lib/adapter/drd';
import propertiesProviderModule from 'dmn-js-properties-panel/lib/provider/dmn';

import "dmn-js-properties-panel/dist/assets/dmn-js-properties-panel.css";
import "dmn-js/dist/assets/diagram-js.css";
import "dmn-js/dist/assets/dmn-font/css/dmn-embedded.css";
import "dmn-js/dist/assets/dmn-js-decision-table-controls.css";
import "dmn-js/dist/assets/dmn-js-decision-table.css";
import "dmn-js/dist/assets/dmn-js-drd.css";
import "dmn-js/dist/assets/dmn-js-literal-expression.css";
import "dmn-js/dist/assets/dmn-js-shared.css";

import { initialDmn } from "./diagram";
import undo from "../../../../../assets/svg/Group 26976.svg"
import Redo from "../../../../../assets/svg/Group 26977.svg"
import { ResourceLock } from '../../../../../helpers/RxServices'
import { Http } from "../../../../../helpers/axois";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { AppState } from "../../../../../stateManager/store";
import { redirectOnError, useToast } from "../../../../../helpers/commonFunction";
import { logger } from "../../../../../constant/winston";
import { onBpmnAction } from "../../../../../stateManager/store/common/action";
import { selectedDmn } from "../../../../../stateManager/store/apps/actions";


const Dmn = (props: any) => {
    const { SuccessToast, ErrorToast } = useToast()
    const [viewer, setViewer]: any = useState({})
    const [resourceLock, setResourceLock] = useState<any>({})
    const params: any = props.match.params;
    const history = useHistory();
    const { dmnId, appId } = params;
    const loggedInUserId = useSelector((state: any) => {
        return state.user.data.user.id
    })
    const [dmnData, setDmnData]: any = useState(null)
    const dispatch = useDispatch()
    const bpmnActionType = useSelector((state: any) => state.common.bpmnActionType)
    const appVersion = useSelector((state: AppState) => state.apps.appVersion && state.apps.appVersion[appId]);
    const versionId = appVersion && appVersion.versionId;
    const currentVersion = appVersion?.currentVersion

    const isCheckedIn: boolean = resourceLock.userId === loggedInUserId;

    const orgPermissions: any = useSelector((state: any) => {
        return state.org.orgPermissions
    }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))

    const appPermissions: any = useSelector((state: any) => {
        return state.apps.selectedApp.permissions
    }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))

    const canEdit = currentVersion && isCheckedIn && (orgPermissions.includes('dmn.Edit') || appPermissions.includes('dmn.Edit'))

    const saveDmn = (isCommit: boolean, discard?: boolean) => {
        viewer?.saveXML((err: any, xml: any) => {
            // const { dmnnName } = dmnData[0]
            const data = {
                // name: dmnnName,
                appId: appId,
                source: xml
            }
            Http.put(`/dmn/${dmnId}?isCommit=${isCommit}${discard ? "&discard=true" : ""}`, data).subscribe((formRes: any) => {
                if (isCommit) {
                    SuccessToast('Dmn committed successfully');
                    if (discard) {
                        getDmn();
                    } else {
                        initialdata()
                    }
                } else {
                    SuccessToast('Dmn saved successfully');
                }
            }, (err) => {
                ErrorToast('Dmn save failed');
            })
        });
    }


    const refetchLockStatus = useCallback((callback?: any) => {
        Http.get(`/apps/${appId}/dmn/${dmnId}?versionId=${versionId}`).subscribe((res: any) => {
            ResourceLock.sendMessage({
                message: 'DMN_REFETCHED',
                resourceLock: res[0].resourceLock || {},
                refetchedCallback: () => callback && callback(res[0].resourceLock)
            })
        })
    }, [appId, dmnId, versionId]);

    const initialdata = useCallback((refetch = false, refetchCallback?: any) => {
        Http.get(`/apps/${appId}/dmn/${dmnId}?versionId=${versionId}`).subscribe((res: any) => {
            dispatch(selectedDmn(res[0]));
            let lockData: any = {
                resourceLock: res[0].resourceLock
            }
            if (refetch) {
                lockData = {
                    ...lockData,
                    message: 'DMN_REFETCHED'
                }
            }
            if (refetchCallback) {
                lockData = {
                    ...lockData,
                    refetchedCallback: () => refetchCallback(res[0].resourceLock)
                }
            }
            // send resource lock data to header
            ResourceLock.sendMessage(lockData)

            // send resource lock data to header
            ResourceLock.sendMessage({
                resourceLock: res[0].resourceLock
            })
            setDmnData(res)
        }, (err) => {
            logger.error("initialData", err);
            const navigateTo = `/apps/list/${appId}/assist/dmn/list`;
            redirectOnError(history, err.message, navigateTo, "View all DMN", "dmnId")
        }
        )
    }, [appId, dmnId, versionId, history])

    const getDmn = () => {
        Http.get(`apps/${appId}/dmn/${dmnId}?versionId=${versionId}`).subscribe((formRes: any) => {
            if (formRes && formRes.length > 0) {
                const canvas: any = document.getElementById("canvas");
                while (canvas && canvas.hasChildNodes()) {
                    canvas.removeChild(canvas.firstChild);
                }
                setViewer({})

                let viewer = new DmnViewer({
                    camunda: camundaModdle,
                    width: "100%",
                    height: "100%",
                    position: "absolute",
                    top: "70px",
                    decisionTable: {
                        keyboard: {
                            bindTo: document
                        }
                    },
                    container: '#canvas',
                    common: {
                        keyboard: {
                            bindTo: document
                        }
                    },
                    drd: {
                        propertiesPanel: {
                            parent: '#properties'
                        },
                        additionalModules: [
                            propertiesPanelModule,
                            propertiesProviderModule,
                            drdAdapterModule
                        ]
                    },
                });

                viewer.importXML(formRes[0].source ? formRes[0].source : initialDmn, (err: any) => {
                    if (err) {
                        return console.log(err);
                    } else {
                        const findPalette = document.getElementsByClassName("djs-palette open")
                        if (findPalette?.length > 0) {
                            const findTools: any = findPalette[0].querySelectorAll(`[data-group="drd"]`)
                            if (findTools.length > 0) {
                                findTools[0].style.paddingLeft = "0px"
                                // findTools[0].style.marginBottom = "10px"
                            }
                            const imgTag = document.createElement("img")
                            const imgTag1 = document.createElement("img")
                            imgTag.src = Redo
                            imgTag.style.transform = "rotate(90deg) translateY(-5px)"
                            imgTag.style.paddingRight = "15px"
                            imgTag.style.height = "20px"
                            imgTag.style.cursor = "pointer"
                            imgTag1.src = undo
                            imgTag1.style.cursor = "pointer"
                            imgTag1.style.height = "20px"
                            imgTag1.style.transform = "rotate(90deg) translateX(5px) translateY(-5px)"
                            imgTag1.style.paddingLeft = "15px"
                            imgTag.addEventListener('click', function handleClick(event: any) {
                                document.dispatchEvent(new KeyboardEvent('keydown', { 'key': 'z', 'ctrlKey': true }));
                            });
                            imgTag1.addEventListener('click', function handleClick(event: any) {
                                document.dispatchEvent(new KeyboardEvent('keydown', { 'key': 'y', 'ctrlKey': true }));
                            });
                            findPalette[0].appendChild(imgTag)
                            findPalette[0].appendChild(imgTag1)

                            const findContianer = document.getElementsByClassName("dmn-drd-container");
                            if (findContianer?.length > 0) {
                                const rect = findContianer[0].getBoundingClientRect()
                                if (rect) {
                                    const findPalette: any = document.getElementsByClassName("djs-palette open")

                                    if (findPalette?.length > 0) {
                                        findPalette[0].style.top = "65%"
                                        findPalette[0].style.position = "fixed"
                                    }
                                }
                            }
                        }
                    }
                });
                setViewer(viewer)
            }
        })
        initialdata();
    }

    useEffect(() => {
        getDmn()
        const subscriber = ResourceLock.getMessage().subscribe(({ resourceLock }) => {
            resourceLock ? setResourceLock(resourceLock) : setResourceLock({})
        })
        return () => subscriber.unsubscribe()
    }, [])

    useEffect(() => {
        if (bpmnActionType === "SAVE") {
            saveDmn(false);
        } else if (bpmnActionType === "COMMIT") {
            saveDmn(true)
        } else if (bpmnActionType === 'DISCARD') {
            saveDmn(true, true)
        }
        dispatch(onBpmnAction(null));
    }, [bpmnActionType])

    useEffect(() => {
        const subscriber = ResourceLock.getMessage().subscribe(({ message, callback }) => {
            if (message === 'DMN_REFETCH') {
                initialdata(true, callback)
            } else if (message === 'DMN_REFETCH_LOCK') {
                callback ? refetchLockStatus(callback) : refetchLockStatus()
            }
        })
        return () => subscriber.unsubscribe()
    }, [initialdata, refetchLockStatus])

    return (
        <>
            <div className="modeler" style={{ display: "flex", flexDirection: "row", height: `95%`, width: "100%" }}>
                {!isCheckedIn && !canEdit && <div style={{ zIndex: 1, position: 'absolute', width: '100%', opacity: 0, height: "100%" }}></div>}
                <div id="canvas" style={{ height: "100%", flexGrow: 1 }}></div>
                <div style={{ height: "100%" }} id="properties"></div>
            </div>
        </>
    )

}

export default Dmn